export enum SocialMediaEnum {
    Website = 'website',
    Twitter = 'twitter',
    Facebook = 'facebook',
}
